'use strict';

var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');

var updateSelection = function() {

	// If we're not in slideshow compare mode
	if (appDom.gallerySelect.length) {

		appDom.gallerySelect[0].selectedIndex = dataMgr.getGalleryIndex();

	}

};

var updateFavoriteCount = function(count) {

	appDom.gallerySelectFavorites.text(appDom.gallerySelectFavorites.text().split('(')[0] + '(' + count + ')');

};

var addEventHandlers = function() {

	appDom.document.on('gallery_data_ready', updateSelection);

	appDom.gallerySelect.on('change', function() {

		// Broadcast the new selected gallery.
		triggerCustomEvent('gallery_select_gallery_selected', {
			data: {
				galleryIndex: parseInt(this.value, 10)					
			}
		});

	});

	appDom.document.on('favorite_count_updated', function(e, data) {

		updateFavoriteCount(data.count);

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {
	init: init
};
